import React, { FC } from 'react';
import styles from './RoundIcon.module.css';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';

export enum RoundIconVariants {
    variant1 = 'round-icon-variant-1',
    variant2 = 'round-icon-variant-2',
    variant3 = 'round-icon-variant-3',
}

export interface RoundIconProps {
    id?: string;
    classes?: string;
    icon?: string;
    text?: string;
    outsideText?: string;
    variant: RoundIconVariants;
    active?: boolean;
    indicator?: number;
    bgImage?: string;
    onClick?: () => void;
}

export const RoundIcon: FC<RoundIconProps> = ({
    id,
    classes,
    icon,
    text,
    outsideText,
    variant,
    active,
    indicator,
    bgImage,
    onClick,
}) => {
    const isSvgIcon = icon?.includes('<svg');

    return (
        <div
            id={id || undefined}
            className={`${styles['round-icon-container']} d-flex align-items-center gap-2`}
            onClick={() => onClick && onClick()}>
            <div
                className={
                    // variant
                    `${styles[variant]}` +
                    // active state
                    ` ${active ? styles.active : ''}` +
                    // background image
                    ` ${bgImage ? styles['bg-image'] : ''}` +
                    // svg icon
                    ` ${isSvgIcon ? styles['svg-icon'] : ''}` +
                    // other classes
                    ` ${classes || ''}`
                }
                style={{ backgroundImage: bgImage ? `url('${bgImage}')` : 'unset' }}
                data-testid="round-icon">
                {icon ? (
                    isSvgIcon ? (
                        <span className={styles['svg-wrapper']} dangerouslySetInnerHTML={{ __html: icon || '' }} />
                    ) : (
                        <Typography tagVariant={TypographyTagVariants.span}>
                            <i className={icon} />
                        </Typography>
                    )
                ) : (
                    <Typography tagVariant={TypographyTagVariants.span}>{text}</Typography>
                )}
                {indicator !== undefined && <span className={styles.indicator}>{indicator}</span>}
            </div>
            {outsideText && (
                <Typography tagVariant={TypographyTagVariants.span} fontSize="14" fontWeight="400">
                    {outsideText}
                </Typography>
            )}
        </div>
    );
};
